import { createContext, useState, useEffect, useContext } from "react";
import PdfViewer from "components/pdf-viewer/pdf-viewer.component";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

import axios from "axios";

import { AuthContext } from "./auth.context";

import { getNow } from "utils/date.utils";
import { useCallback } from "react";
import { useMemo } from "react";
import MoveFileModal from "components/move-file-modal/move-file-modal.component";

export const FolderContext = createContext({
	files: {},
	currentLocation: [],
	focusedFiles: {},
	currentLocationMoveFile: [],
	focusedFilesMoveFile: {},
	openedFile: null,
	openFile: () => {},
	renameFolder: () => {},
	deleteFolder: () => {},
	getInside: () => {},
	getInsideMoveFile: () => {},
	goBack: () => {},
	goBackMoveFile: () => {},
	addFolder: () => {},
	addFile: () => {},
	sortFiles: () => {},
	deleteFile: () => {},
	setFileToBeMoved: () => {},
	moveFile: () => {},
	updateRef: () => {},
	getUpdatedFile: () => {},
});

const initialFolderState = {
	PURCHASES: {
		isLocked: false,
		folders: {
			"Quarter 1": {
				isLocked: false,
				files: [],
				folders: {},
			},
			"Quarter 2": {
				isLocked: false,
				files: [],
				folders: {},
			},
			"Quarter 3": {
				isLocked: false,
				files: [],
				folders: {},
			},
			"Quarter 4": {
				isLocked: false,
				files: [],
				folders: {},
			},
		},
		files: [],
	},
	SALES: {
		isLocked: false,
		folders: {
			"Quarter 1": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 2": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 3": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 4": {
				isLocked: false,
				folders: {},
				files: [],
			},
		},
		files: [],
	},
	TAXES: {
		isLocked: false,
		folders: {
			"Quarter 1": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 2": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 3": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 4": {
				isLocked: false,
				folders: {},
				files: [],
			},
		},
		files: [],
	},
	BANKS: {
		isLocked: false,
		folders: {
			"Quarter 1": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 2": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 3": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 4": {
				isLocked: false,
				folders: {},
				files: [],
			},
		},
		files: [],
	},
	VAT: {
		isLocked: false,
		folders: {
			"Quarter 1": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 2": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 3": {
				isLocked: false,
				folders: {},
				files: [],
			},
			"Quarter 4": {
				isLocked: false,
				folders: {},
				files: [],
			},
		},
		files: [],
	},
	// PURCHASES2: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// SALES2: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// TAXES2: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// BANKS2: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// VAT2: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// PURCHASES3: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// SALES3: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// TAXES3: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// BANKS3: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// VAT3: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// PURCHASES4: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// SALES4: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// TAXES4: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// BANKS4: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
	// VAT4: {
	// 	isLocked: false,
	// 	files: {
	// 		"Quarter 1": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 2": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 3": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 		"Quarter 4": {
	// 			isLocked: false,
	// 			files: {},
	// 		},
	// 	},
	// },
};

const organizeCurrentFolders = (list) => {
	const { folders, files } = list;

	const organizedList = {
		files: [],
		folders: [],
	};

	Object.keys(folders).forEach((fileName) => {
		const newFile = {
			fileName,
			isEmpty: Object.keys(folders[fileName]?.files ?? {}).length === 0,
			folderId: folders[fileName].folderId,
		};
		organizedList["folders"] = [...organizedList["folders"], newFile];
		// const type = fileName.indexOf(".") === -1 ? "folders" : "files";
		// if (type === "folders") {
		// 	const newFile = {
		// 		fileName,
		// 		isEmpty: Object.keys(folders[fileName]?.files ?? {}).length === 0,
		// 	};
		// 	organizedList[type] = [...organizedList[type], newFile];
		// } else {
		// 	// const newFile = {
		// 	// 	createdAt: folders[fileName].createdAt,
		// 	// 	file: folders[fileName].file,
		// 	// 	ref: folders[fileName].ref,
		// 	// };
		// 	// organizedList[type] = [...organizedList[type], newFile];
		// }
	});
	organizedList.files = files;
	return organizedList;
};

const getFiles = async (userId) => {
	// var errorFlag = false;
	// const resp = await axios
	// 	.get(`/getFiles?userId=${userId}`)
	// 	.then((res) => res.data)
	// 	.catch((err) => {
	// 		errorFlag = true;
	// 		return err;
	// 	});
	// if (errorFlag) return null;
	// return resp;
};

const renameFunction = () => {
	let index = 1;

	return function (fileName) {
		if (index === 0) return fileName;
		return `${fileName} (${index++})`;
	};
};

const addFolderToServer = (userId, folderName, currentLocation) => {
	const path = currentLocation.join("/");
	console.log("Adding:", {
		userId,
		location: path,
		folderName,
	});
	axios.post("/addFolder", {
		userId,
		location: path,
		folderName,
	});
};

const uploadFile = async (userId, file, currentLocation) => {
	var errorFlag = false;

	const path = currentLocation.join("/");

	// const resp = await axios
	// 	.get(`/getSecurePut?userId=${userId}&location=${path}&fileName=${file.file.name}`)
	// 	.then((res) => res.data)
	// 	.catch((err) => {
	// 		errorFlag = true;
	// 		return err;
	// 	});

	// if (errorFlag) return null;

	// console.log({ resp });

	// await fetch(resp, {
	// 	method: "PUT",
	// 	headers: {
	// 		"Content-type": "multipart/form-data",
	// 	},
	// 	body: file.file,
	// }).catch((err) => {
	// 	console.log({ errorOnUploadPhotoPut: err });
	// });

	// .then((res) => res.json())
	// .then((data) => console.log(data))

	// axios
	// 	.post("/addFileInfo", {
	// 		userId,
	// 		location: path,
	// 		fileName: file.name,
	// 		createdAt: new Date(),
	// 		red: "N/A",
	// 	})
	// 	.then(console.log)
	// 	.catch(console.error);
};

const getFileLinkFromServer = async (userId, fileName) => {
	console.log({ userId, fileName });
	var errorFlag = false;

	const resp = await axios
		.get(`/getSecureRead?userId=${userId}&objectName=${fileName}`)
		.then((res) => res.data)
		.catch((err) => {
			errorFlag = true;
			return err;
		});
	console.log({ resp });

	if (errorFlag) return "";
	return resp;
};

const sendRenameRequest = async (userId, location, oldName, newName, folderId) => {
	console.log({ userId, location, oldName, newName, folderId });
	var errorFlag = false;
	const resp = await axios
		.post("/renameFolder", { userId, location, folderName: oldName, newName, folderId })
		.then((res) => res.data)
		.catch((err) => {
			errorFlag = true;
			return err;
		});

	if (errorFlag) return null;
	return resp;
};

// PART component start
const FolderProvider = ({ children }) => {
	const { user } = useContext(AuthContext);

	// const [files, setFiles] = useState({});
	const [files, setFiles] = useState(initialFolderState);
	const [currentLocation, setCurrentLocation] = useState([]);
	const [focusedFiles, setFocusedFiles] = useState({
		files: [],
		folders: [],
	});
	const [fileToBeMoved, setFileToBeMoved] = useState(null);
	const [currentLocationMoveFile, setCurrentLocationMoveFile] = useState([]);
	const [focusedFilesMoveFile, setFocusedFilesMoveFile] = useState({
		files: [],
		folders: [],
	});
	const [openedFileInfo, setOpenedFileInfo] = useState({}); // {fileName, directory}

	const getFileByName = useCallback(
		(fileName, directory = currentLocation) => {
			if (directory.length === 0) return;

			const newFiles = { ...files };
			var tempCurrentLocation = newFiles;
			directory.slice(0, -1).forEach((folderName) => {
				tempCurrentLocation = tempCurrentLocation[folderName].folders;
			});

			tempCurrentLocation = tempCurrentLocation[currentLocation[currentLocation.length - 1]].files;

			const file = tempCurrentLocation.find((_file) => _file.file.name === fileName);

			return file;
		},
		[files, currentLocation]
	);

	const openedFile = useMemo(() => {
		const file = getFileByName(openedFileInfo.fileName, openedFileInfo.directory);
		if (file) return { ...file, url: openedFileInfo.url };
		return null;
	}, [openedFileInfo, getFileByName]);

	useEffect(() => {
		if (user) {
			(async () => {
				const files = await getFiles(user.userId);
				// console.log({ files });
				if (files) {
					const f = files[""].folders;
					setFiles(f);
				}
			})();
		}
	}, [user]);

	const getData = useCallback(
		(directory = currentLocation, _files = files) => {
			if (directory.length === 0) return _files;

			var data = _files;
			directory.slice(0, -1).forEach((folderName) => {
				data = data[folderName].folders;
			});

			data = data[directory[directory.length - 1]]; // {isLocked, folders, files}

			return data;
		},
		[currentLocation, files]
	);

	const getInside = useCallback(
		(folderName, isRootFile = false) => {
			// if folderName exists: get inside of that folder; else: return files in the root
			if (isRootFile) {
				// if it is a root folder
				setCurrentLocation([folderName]);
				return;
			}
			if (folderName) {
				// if it is not a root folder
				const newList = [...currentLocation, folderName];
				setCurrentLocation(newList);
				return;
			}
		},
		[currentLocation]
	);

	const getInsideMoveFile = useCallback(
		(folderName) => {
			const isRootFile = currentLocationMoveFile.length === 0;

			// if folderName exists: get inside of that folder; else: return files in the root
			if (isRootFile) {
				// if it is a root folder
				setCurrentLocationMoveFile([folderName]);
				return;
			}
			if (folderName) {
				// if it is not a root folder
				const newList = [...currentLocationMoveFile, folderName];
				setCurrentLocationMoveFile(newList);
				return;
			}
		},
		[currentLocationMoveFile]
	);

	const goBack = useCallback(() => {
		if (currentLocation.length === 0) return;

		let newList = [...currentLocation];
		newList.pop();
		setCurrentLocation(newList);
	}, [currentLocation]);

	const goBackMoveFile = useCallback(() => {
		if (currentLocationMoveFile.length === 0) return;

		let newList = [...currentLocationMoveFile];
		newList.pop();
		setCurrentLocationMoveFile(newList);
	}, [currentLocationMoveFile]);

	const addFolder = useCallback(
		//TODO: add add request

		(name, isRoot = false) => {
			var updatedName = "New Folder";
			var filesWithSameName = [];

			const rename = renameFunction();
			var checkDuplicate = ({ fileName }) => {
				return fileName === updatedName;
			};

			if (isRoot) {
				checkDuplicate = (name) => {
					return name === updatedName;
				};

				filesWithSameName = Object.keys(files).filter(checkDuplicate);
				while (filesWithSameName.length > 0) {
					updatedName = rename("New Folder");
					filesWithSameName = Object.keys(files).filter(checkDuplicate);
				}

				addFolderToServer(user?.userId, updatedName, []);

				setFiles((initialFiles) => {
					const newFiles = { ...initialFiles };
					newFiles[updatedName] = {
						isLocked: false,
						folders: {},
						files: [],
					};
					return newFiles;
				});
				return;
			}

			filesWithSameName = focusedFiles.folders.filter(checkDuplicate);
			while (filesWithSameName.length > 0) {
				updatedName = rename("New Folder");
				filesWithSameName = focusedFiles.folders.filter(checkDuplicate);
			}

			// I have no idea how this works, but it does
			addFolderToServer(user?.userId, updatedName, currentLocation);

			var data = getData();

			data.folders[updatedName] = {
				isLocked: false,
				folders: {},
				files: [],
			};

			const temp = { ...files };
			setFiles(temp);
		},
		[user, currentLocation, files, focusedFiles, getData]
	);

	const renameFolder = useCallback(
		(oldFolderName, newFolderName, folderId, directory = currentLocation) => {
			if (oldFolderName.trim() === newFolderName.trim()) return;

			var updatedName = newFolderName;
			var filesWithSameName = [];

			const rename = renameFunction();
			const checkDuplicate = (name) => {
				return name === updatedName;
			};

			if (directory.length === 0) {
				// if root folder

				filesWithSameName = Object.keys(files).filter(checkDuplicate);
				while (filesWithSameName.length > 0) {
					updatedName = rename(newFolderName);
					filesWithSameName = Object.keys(files).filter(checkDuplicate);
				}

				setFiles((initialFiles) => {
					const newFiles = { ...initialFiles };
					if (oldFolderName !== newFolderName) {
						Object.defineProperty(
							newFiles,
							newFolderName,
							Object.getOwnPropertyDescriptor(newFiles, oldFolderName)
						);
						delete newFiles[oldFolderName];
					}
					return newFiles;
				});
				return;
			}

			const folders = getData(directory).folders;

			filesWithSameName = Object.keys(folders).filter(checkDuplicate);

			while (filesWithSameName.length > 0) {
				updatedName = rename(newFolderName);
				filesWithSameName = Object.keys(folders).filter(checkDuplicate);
			}

			setFiles((oldValue) => {
				const newValue = { ...oldValue };
				const tempCurrentLocation = getData(directory, newValue).folders;

				if (oldFolderName !== updatedName) {
					Object.defineProperty(
						tempCurrentLocation,
						updatedName,
						Object.getOwnPropertyDescriptor(tempCurrentLocation, oldFolderName)
					);
					delete tempCurrentLocation[oldFolderName];
				}

				return newValue;
			});

			sendRenameRequest(user.userId, directory.join("/"), oldFolderName, updatedName, folderId);
		},
		[user, files, currentLocation, getData]
	);

	const deleteFolder = useCallback(
		(folderName, directory = currentLocation) => {
			setFiles((oldValue) => {
				const newValue = { ...oldValue };
				var tempCurrentLocation = newValue;
				directory.slice(0, -1).forEach((folderName) => {
					tempCurrentLocation = tempCurrentLocation[folderName].folders;
				});
				tempCurrentLocation = tempCurrentLocation[directory[directory.length - 1]].folders;

				delete tempCurrentLocation[folderName];

				return newValue;
			});
		},
		[currentLocation]
	);

	const addFile = useCallback(
		(file, newDirectory = currentLocation, isNewFile = true) => {
			//TODO: add add request
			const fileToBeAdded = isNewFile ? { file, createdAt: getNow(), ref: "" } : file;
			var updatedName = fileToBeAdded.file.name;

			const rename = renameFunction();
			const checkDuplicate = ({ file: { name } }) => {
				return name === updatedName;
			};
			const newFiles = { ...files };
			var tempCurrentLocation = newFiles;

			newDirectory.slice(0, -1).forEach((folderName) => {
				tempCurrentLocation = tempCurrentLocation[folderName].folders;
			});
			tempCurrentLocation = tempCurrentLocation[newDirectory[newDirectory.length - 1]].files;

			var filesWithSameName = tempCurrentLocation.filter(checkDuplicate);
			while (filesWithSameName.length > 0) {
				updatedName = rename(fileToBeAdded.file.name);
				filesWithSameName = tempCurrentLocation.filter(checkDuplicate);
			}
			fileToBeAdded.file = new File([fileToBeAdded.file], updatedName);
			// const updatedFile = new File([fileToBeAdded.file], updatedName);

			uploadFile(user.userId, fileToBeAdded, newDirectory);

			tempCurrentLocation.push(fileToBeAdded);
			setFiles(newFiles);
		},
		[user, files, currentLocation]
	);

	const sortFiles = useCallback(
		//TODO: add sort request

		(newDocs) => {
			setFiles((initialFiles) => {
				const newFiles = { ...initialFiles };
				var tempCurrentLocation = newFiles;
				currentLocation.slice(0, -1).forEach((folderName) => {
					tempCurrentLocation = tempCurrentLocation[folderName].folders;
				});

				tempCurrentLocation[currentLocation[currentLocation.length - 1]].files = newDocs;

				return newFiles;
			});
		},
		[currentLocation]
	);

	const openFile = useCallback(
		async (fileName, isOriginal = false, directory = currentLocation) => {
			const link = await getFileLinkFromServer(
				user.userId,
				"Concert_In_G_Major_RV310_-_Vivaldi_Solo_Violin.pdf"
			);
			setOpenedFileInfo({ fileName, directory, isOriginal, url: link });
		},
		[user, currentLocation]
	);

	const deleteFile = useCallback(
		// deletes file and returns the deleted file
		//TODO: send delete request

		(fileName) => {
			var file = null;
			if (fileName) {
				const index = focusedFiles.files.findIndex(({ file }) => file.name === fileName);
				file = focusedFiles.files[index];
			}

			setFiles((oldValue) => {
				const newValue = { ...oldValue };
				var tempCurrentLocation = newValue;
				currentLocation.slice(0, -1).forEach((folderName) => {
					tempCurrentLocation = tempCurrentLocation[folderName].folders;
				});

				tempCurrentLocation[currentLocation[currentLocation.length - 1]].files =
					tempCurrentLocation[currentLocation[currentLocation.length - 1]].files.filter(
						({ file: { name } }) => fileName !== name
					);

				return newValue;
			});

			return file;
		},
		[currentLocation, focusedFiles]
	);

	const moveFile = useCallback(() => {
		const file = deleteFile(fileToBeMoved);
		addFile(file, currentLocationMoveFile, false);
		setFileToBeMoved(null);
		setCurrentLocationMoveFile([]);
	}, [fileToBeMoved, currentLocationMoveFile, addFile, deleteFile]);

	const updateRef = useCallback(
		(newRef) => {
			const { fileName, directory } = openedFileInfo;

			setFiles((oldValue) => {
				const newValue = { ...oldValue };
				var tempCurrentLocation = newValue;
				directory.slice(0, -1).forEach((folderName) => {
					tempCurrentLocation = tempCurrentLocation[folderName].folders;
				});

				tempCurrentLocation[directory[directory.length - 1]].files = tempCurrentLocation[
					directory[directory.length - 1]
				].files.map((_file) => {
					if (_file.file.name !== fileName) return _file;
					return { ..._file, ref: newRef };
				});

				return newValue;
			});
		},
		[openedFileInfo]
	);

	const getUpdatedFile = useCallback(async (file, textToBeWritten) => {
		const buffer = await file.arrayBuffer();

		const pdfDoc = await PDFDocument.load(buffer);
		const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

		const pages = pdfDoc.getPages();
		const firstPage = pages[0];
		const { width, height } = firstPage.getSize();

		firstPage.drawText(textToBeWritten, {
			x: width * 0.6,
			y: height - (height > 300 ? 30 : height * 0.1) - 5,
			maxWidth: width * 0.35,
			wordBreaks: [""],
			size: height > 300 ? 30 : height * 0.1,
			font: helveticaFont,
			color: rgb(0, 0, 0),
		});

		const pdfBytes = await pdfDoc.save();

		return new Blob([pdfBytes.buffer]);
	}, []);

	useEffect(() => {
		if (currentLocation.length !== 0) {
			let data = getData();
			const organizedList = organizeCurrentFolders(data);
			setFocusedFiles(organizedList);
		}
	}, [currentLocation, files, getData]);

	useEffect(() => {
		if (currentLocationMoveFile.length !== 0) {
			let data = getData(currentLocationMoveFile);
			const organizedList = organizeCurrentFolders(data);
			setFocusedFilesMoveFile(organizedList);
		} else {
			const folders = Object.keys(files).map((folderName, index) => {
				const childrenFolders = files[folderName]?.files ?? {};
				const isEmpty = Object.keys(childrenFolders)?.length === 0;
				return { fileName: folderName, isEmpty };
			});
			setFocusedFilesMoveFile({ files: [], folders });
		}
	}, [currentLocationMoveFile, files, getData]);

	const value = useMemo(
		() => ({
			files,
			currentLocation,
			focusedFiles,
			focusedFilesMoveFile,
			currentLocationMoveFile,
			openedFile,
			getInside,
			getInsideMoveFile,
			goBack,
			goBackMoveFile,
			addFolder,
			renameFolder,
			deleteFolder,
			addFile,
			openFile,
			sortFiles,
			deleteFile,
			setFileToBeMoved,
			moveFile,
			updateRef,
			getUpdatedFile,
		}),
		[
			files,
			currentLocation,
			focusedFiles,
			focusedFilesMoveFile,
			currentLocationMoveFile,
			openedFile,
			getInside,
			getInsideMoveFile,
			goBack,
			goBackMoveFile,
			addFolder,
			renameFolder,
			deleteFolder,
			addFile,
			openFile,
			sortFiles,
			deleteFile,
			setFileToBeMoved,
			moveFile,
			updateRef,
			getUpdatedFile,
		]
	);
	return (
		<FolderContext.Provider value={value}>
			{openedFile && <PdfViewer viewOriginal={openedFileInfo?.isOriginal ?? false} />}
			{fileToBeMoved && (
				<MoveFileModal
					dismiss={() => {
						setFileToBeMoved(null);
						setCurrentLocationMoveFile([]);
					}}
				/>
			)}
			<div>{children}</div>
		</FolderContext.Provider>
	);
};

export default FolderProvider;
